import { HttpBadStatusCodeError } from '@cian/peperrors/shared';
// oxlint-disable-next-line cian-eslint-compat/no-restricted-paths
import { EStatus } from '../../../node/repositories/newbuilding-card/entities/reviews/Like';
import { setReviewReactionAction } from '../../../shared/actions/newbuilding';
import { EType } from '../../../shared/repositories/newbuilding-reviews/entities/set_review_reaction/SetReviewReactionRequest';
import {
  fetchSetReviewReactionWeb,
  TSetReviewReactionWebResponse,
} from '../../../shared/repositories/newbuilding-reviews/v1/set-review-reaction-web';

import { getProductsData, getUser } from '../../../shared/selectors/analytics';
import { getBuilders, getNewbuildingId, getReviewsStat, getReviewById } from '../../../shared/selectors/newbuilding';
import { TThunkAction } from '../../../shared/types/redux/thunk';
import { getLabelFromState, trackNewbuildingReviewsAnalytic } from '../../../shared/utils/analytics/reviewsAnalytics';

interface IParams {
  reviewId: string;
  type: EStatus;
}

export const setReviewReaction = ({ reviewId, type }: IParams): TThunkAction<Promise<void>> => {
  return async (dispatch, getState, context) => {
    const { logger, httpApi } = context;

    try {
      const { response, statusCode }: TSetReviewReactionWebResponse = await fetchSetReviewReactionWeb({
        httpApi,
        parameters: { reviewId, type: type as unknown as EType },
      });

      if (statusCode !== 200) {
        throw new HttpBadStatusCodeError({
          statusCode,
          message: 'Ошибка запроса на изменение реакции',
          domain: 'src/browser/services/reviews/setReviewReaction.ts',
        });
      }

      // oxlint-disable-next-line typescript/no-explicit-any
      dispatch(setReviewReactionAction({ reviewId, type: response.type as unknown as EStatus }) as any);

      const state = getState();

      const user = getUser(state);

      const builder = getBuilders(state)[0] || null;
      const id = getNewbuildingId(state);
      const products = [getProductsData(id, builder)];

      const review = getReviewById(reviewId)(state) || { like: { status: EStatus.Unknown } };
      const label = getLabelFromState({ state: review.like.status, payload: type });

      const reviewsStat = getReviewsStat(state);

      const page = {
        pageType: 'CardJK',
        siteType: 'desktop',
        extra: {
          type: 'review',
          review_id: reviewId,
          rating: reviewsStat?.rating,
        },
      };

      trackNewbuildingReviewsAnalytic({
        action: 'Click_sopr',
        category: 'NewbuildingReviews',
        label,
        user,
        page,
        products,
      });
    } catch (error) {
      logger.error(error, {
        domain: 'setReviewReaction',
        message: error.message,
      });
    }
  };
};
